import { howDoYouKnowUsValues } from '@asgard/api-common';
import { EMAIL_REGEX } from '@asgard/utils';
import { FormSelectOption } from 'components/form/FormSelect/FormSelect.types';
import { i18n } from 'next-i18next';
import { z } from 'zod';
import { ConsultancyFormFields } from './Form.types';

const I18N_PREFIX = 'consultancy';

export const DEFAULT_TYPE_OPTION: FormSelectOption = {
  label: 'SELECT_ONE',
  value: ''
};

export const ConsultancyFormFieldsSchema = z.object({
  name: z.string(),
  email: z.string(),
  description: z.string(),
  company: z.string(),
  contactPhone: z.string().optional(),
  terms: z.boolean().optional(),
  howDoYouKnowUs: z.enum(howDoYouKnowUsValues),
  isSubscribeToNewsletter: z.boolean()
});

export const ConsultancyFormFieldsValidationSchema =
  ConsultancyFormFieldsSchema.partial()
    // Name required
    .refine((schema) => !!schema.name, {
      path: ['name'],
      message: i18n?.t(`${I18N_PREFIX}.form.required-name`, { ns: I18N_PREFIX })
    })

    // Email required
    .refine((schema) => !!schema.email, {
      path: ['email'],
      message: i18n?.t(`${I18N_PREFIX}.form.required-email`, {
        ns: I18N_PREFIX
      })
    })

    // Email format
    .refine((schema) => schema.email?.match(EMAIL_REGEX), {
      path: ['email'],
      message: i18n?.t(`${I18N_PREFIX}.form.invalid-email`, { ns: I18N_PREFIX })
    })

    // Description required
    .refine((schema) => !!schema.description, {
      path: ['description'],
      message: i18n?.t(`${I18N_PREFIX}.form.required-description`, {
        ns: I18N_PREFIX
      })
    })

    // How do you know us required
    .refine((schema) => !!schema.howDoYouKnowUs, {
      path: ['howDoYouKnowUs'],
      message: i18n?.t(`${I18N_PREFIX}.form.required-how-do-you-know-us`, {
        ns: I18N_PREFIX
      })
    })

    // company required
    .refine((schema) => !!schema.company, {
      path: ['company'],
      message: i18n?.t(`${I18N_PREFIX}.form.required-company`, {
        ns: I18N_PREFIX
      })
    });

export const FORM_FIELDS_DEFAULT_VALUES: Partial<ConsultancyFormFields> = {
  name: '',
  email: '',
  description: '',
  company: '',
  contactPhone: '',
  howDoYouKnowUs: undefined,
  isSubscribeToNewsletter: false
};
